import cn from 'classnames';

import type { PropsWithChildren } from 'react';

import type { MenuGroupProps } from './menu-group.types';

import './menu-group.scss';

export default function MenuGroup(props: PropsWithChildren<MenuGroupProps>): JSX.Element {
  const { children, className, ...rest } = props;

  const classes = cn('rbui-menu-group', className);

  return (
    <li className="rbui-menu-group__container">
      <ul className={classes} role="group" {...rest}>
        {children}
      </ul>
    </li>
  );
}

MenuGroup.displayName = 'MenuGroup';
